import api from 'api';

export const loadBusinessPartners = api('GET /api/io/fields/business-partners');
export const loadCurrencies = api('GET /api/io/fields/currencies');
export const loadPaymentTerms = api('GET /api/io/fields/payment-terms');
export const loadInvoiceRequirements = api(
  'GET /api/io/fields/payment-terms-requirements'
);
export const loadExpenseTypes = api('GET /api/io/fields/expense-types');
export const loadTrafficRestrictions = api(
  'GET /api/io/fields/traffic-restrictions'
);

export const loadReasons = api('GET /api/io/fields/reasons');
export const loadParagraphIndication = api(
  'GET /api/io/fields/paragraph-indication'
);
